import React, {useMemo} from 'react';
import {setViewData} from '../../api';
import {useAssetViewForm} from '../../hooks';
import {type IAssetView} from '../../schema';
import {
	AssetViewManagerDialog,
	type AssetViewManagerDialogProps,
} from './AssetViewManagerDialog';

export interface AssetViewManagerDialogContainerProps
	extends Omit<AssetViewManagerDialogProps, 'form' | 'onSubmit'> {
	onCompleted?: (uuid: string, assetView: IAssetView) => void;
}

export const AssetViewManagerDialogContainer = ({
	assetView,
	onCompleted,
	...props
}: AssetViewManagerDialogContainerProps) => {
	const initialValues = useMemo(
		() => ({
			name: assetView.name,
			description: assetView.description,
		}),
		[assetView],
	);

	const {form, onSubmit} = useAssetViewForm({
		initialValues,
		submit: async (data) => {
			const _assetView = {
				...assetView,
				...data,
			};
			const uuid = await setViewData({assetView: _assetView});
			onCompleted?.(uuid, _assetView);
		},
	});
	return (
		<AssetViewManagerDialog
			{...props}
			assetView={assetView}
			form={form}
			onSubmit={onSubmit}
		/>
	);
};
